import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import HotelsEditForm from './HotelsEditForm';

const HotelsEdit = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Hotel" title="Edit hotel" subParent="Hotels" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Edit hotel</H5>
                <Link to="/hotels">
                  <Btn color="primary">Back to hotel</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <HotelsEditForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HotelsEdit;
